import { render, staticRenderFns } from "./StatementFiles.vue?vue&type=template&id=459e9801&"
import script from "./StatementFiles.vue?vue&type=script&lang=js&"
export * from "./StatementFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports